import { FC } from 'react';
import { RiskEntitiesOverview } from '../api/types/RiskEntities';
import { SEVERITIES_INFO } from '../../../consts/Severity';
import { RISK_SEVERITY } from '@silverfort-nodelibs/common/utils/insight';

interface Props {
    riskEntitiesOverview: RiskEntitiesOverview;
}

type LegendData = {
    name: string;
    fill: string;
    value: number;
};

const RiskBarLegend: FC<Props> = ({ riskEntitiesOverview }) => {
    const data: LegendData[] = [
        {
            name: SEVERITIES_INFO[RISK_SEVERITY.CRITICAL].label,
            fill: SEVERITIES_INFO[RISK_SEVERITY.CRITICAL].color,
            value: riskEntitiesOverview?.[RISK_SEVERITY.CRITICAL] ?? 0
        },
        {
            name: SEVERITIES_INFO[RISK_SEVERITY.HIGH].label,
            fill: SEVERITIES_INFO[RISK_SEVERITY.HIGH].color,
            value: riskEntitiesOverview?.[RISK_SEVERITY.HIGH] ?? 0
        },
        {
            name: SEVERITIES_INFO[RISK_SEVERITY.MEDIUM].label,
            fill: SEVERITIES_INFO[RISK_SEVERITY.MEDIUM].color,
            value: riskEntitiesOverview?.[RISK_SEVERITY.MEDIUM] ?? 0
        }
    ];

    return (
        <div className="h-20 flex flex-col gap-1">
            {data.map((legendData) => (
                <div key={legendData.name} className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className={`h-1 w-1 rounded-[1px] bg-${legendData.fill}`} />
                        <div className="text-12 font-sf">{legendData.name}</div>
                    </div>
                    <div className="text-12 font-medium font-sf">{legendData.value}</div>
                </div>
            ))}
        </div>
    );
};

export default RiskBarLegend;
